import { BlockTrainStatusEnum, StatusTicketEnum } from '@types'

export const INPUT_INT_NUMBER_ACCEPT_KEYS = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0',
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'Tab',
]

const { TRANSIT, NO_SHOW, CANCELED, DELIVERED } = StatusTicketEnum

export const ticketStatusToDisablePrimaryButtonforAdmin = [TRANSIT, NO_SHOW, CANCELED, DELIVERED]

export const PAGINATION_KEYS = {
  PAGE: 1,
  LIMIT: 10,
}

export const PAGINATION_CARRIERS_KEYS = {
  PAGE: 1,
  LIMIT: 20,
}

interface TimeOption {
  value: string
  labelKey: string
  intValue: number
}

export const STATUS_TRANSITIONS = {
  [BlockTrainStatusEnum.LOADING]: BlockTrainStatusEnum.WAITING_APPROVAL,
  [BlockTrainStatusEnum.WAITING_APPROVAL]: BlockTrainStatusEnum.AUTHORIZED,
  [BlockTrainStatusEnum.AUTHORIZED]: BlockTrainStatusEnum.TRANSIT,
  [BlockTrainStatusEnum.TRANSIT]: BlockTrainStatusEnum.UNLOADING,
  [BlockTrainStatusEnum.UNLOADING]: BlockTrainStatusEnum.FINISHED,
  [BlockTrainStatusEnum.FINISHED]: null,
  [BlockTrainStatusEnum.CANCELED]: null,
}

export const TIME_OPTIONS_CONFIG: TimeOption[] = [
  { value: '12:00', labelKey: 'globals.morning_shift', intValue: 12 },
  { value: '18:00', labelKey: 'globals.afternoon_shift', intValue: 18 },
]

export { LOCAL_STORAGE_KEYS } from './localStorageKeys'
export { ROUTE_KEYS } from './routeKeys'
